import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import {
  useEquipment,
  useDetector,
  useInstallation,
} from "@services/servicesGenericsTables";
import { Loading } from "@app/components";
import { useBackgroundCodes } from "@services/servicesGenericsTables/useBackgroundCodes";
import { useBackground } from "../utils/useBackground";

export default function BackgroundListLayout() {
  const fetched = useRef(false);

  const { fetchAll } = useEquipment();
  const { fetchAll: fetchAllDetector } = useDetector();
  const { fetchAll: fetchBackgroundCodes } = useBackgroundCodes();
  const { fetchAll: fetchAllBackground, loading } = useBackground();
  const { fetchAll: fetchAllInstallation } = useInstallation();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      fetchAll();
      fetchBackgroundCodes();
      fetchAllBackground();
      fetchAllDetector();
      fetchAllInstallation();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
